module.exports = __webpack_public_path__ + "static/media/wizualizacja-52.42752924.png";